import { composeInitialState } from '@opengov/compose-app';

import { composeStateMachine } from '@opengov/reporting-app/module';

export const ShareLinkModalInitialState = composeInitialState({
  snapshotLink: null,
  isSnapshotLinkCopied: false,
  permalinkLink: null,
  isPermalinkLinkCopied: false
});

export const shareLinkModalState = composeStateMachine('share-report-link', ShareLinkModalInitialState, (compose) => ({
  setShareLinks: compose.action((state, payload: { snapshotLink: string | null; permalinkLink: string | null }) => {
    return state.set('snapshotLink', payload.snapshotLink).set('permalinkLink', payload.permalinkLink);
  }),
  setSnapshotLinkCopied: compose.action((state, payload: boolean) => {
    return state.set('isSnapshotLinkCopied', payload);
  }),
  setPermalinkLinkCopied: compose.action((state, payload: boolean) => {
    return state.set('isPermalinkLinkCopied', payload);
  })
}));

export const {
  actions: shareLinkActions,
  actionCreators: shareLinkActionCreators,
  selector: shareLinkSelector,
  reducer: shareLinkReducer
} = shareLinkModalState;
